import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Button, Table, Icon, Input } from 'semantic-ui-react';
import API from '../../utils/API';
import errorHandler from '../../utils/errorHandler';
import { getTemplateFolders } from '../../actions/folders';
import DeleteConfirmPopup from '../Common/DeleteConfirmPopup';
import { toastSuccess } from '../../utils/toastMessage';

const FoldersItems = React.memo(({ folder, getTemplateFolders, warningWhenDeleting }) => {
  const name = folder.text;
  const folderId = folder.key;
  const [isEditableName, setIsEditableName] = useState(false);
  const [currentFolderName, setCurrentFolderName] = useState(name);
  const [isError, setIsError] = useState(false);
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);
  const [isLoadingEdit, setIsLoadingEdit] = useState(false);
  const [isCreateError, setCreateError] = useState(false);
  const [isDeleteModal, setDeleteModal] = useState(false);

  const toggleDeleteModal = () => {
    setDeleteModal(!isDeleteModal);
  };

  const onEditClick = useCallback(() => {
    setIsEditableName(true);
  });

  const onChangeName = useCallback((e) => {
    if (isError) setIsError(false);
    if (isCreateError) setCreateError(false);
    setCurrentFolderName(e.target.value);
  });

  const applyChanges = useCallback(() => {
    const trimmedCurrentFolderName = currentFolderName.trim();
    if (
      trimmedCurrentFolderName === '' ||
      trimmedCurrentFolderName.length < 2 ||
      trimmedCurrentFolderName.length > 50
    ) {
      setIsError(true);
      setCreateError(true);
      return;
    }
    setIsLoadingEdit(true);
    API.put(`/templateFolder/${folderId}.`, {
      title: currentFolderName,
    })
      .then(() => {
        getTemplateFolders();
        setIsEditableName(false);
        setIsLoadingEdit(false);
      })
      .catch(function (error) {
        const errorConfig = {
          400: {
            message: 'Папка с таким названием уже существует',
          },
        };
        if (error.response) {
          setCreateError(true);
          setIsLoadingEdit(false);
          errorHandler(error.response.status, errorConfig);
        }
      });
  });

  const discardChanges = useCallback(() => {
    setCurrentFolderName(name);
    setIsEditableName(false);
  });

  const onDeleteClick = useCallback(() => {
    setIsLoadingDelete(true);
    API.delete(`/templateFolder/${folderId}.`, {
      title: currentFolderName,
    })
      .then(() => {
        getTemplateFolders();
        setIsEditableName(false);
        setIsLoadingDelete(false);
        toastSuccess('Папка успешно удалена');
      })
      .catch(function (error) {
        const errorConfig = {
          404: {
            message: 'Не удалось удалить папку',
          },
        };
        if (error.response) {
          setIsEditableName(false);
          setIsLoadingDelete(false);
          errorHandler(error.response.status, errorConfig);
        }
      });
  });

  const onKeyPressHandler = (event) => {
    if (event.key === 'Enter') {
      applyChanges();
    }
  };

  let buttonDisable = false;

  if (name === 'Неразобранное') {
    buttonDisable = true;
  }
  return (
    <Table.Row>
      <Table.Cell>
        {isEditableName ? (
          <React.Fragment>
            <Input
              value={currentFolderName}
              onChange={onChangeName}
              error={isError}
              onKeyPress={onKeyPressHandler}
              // eslint-disable-next-line react/jsx-no-duplicate-props
              error={isCreateError}
            />
            {isError && (
              <ErrorText>Название папки должно содержать от 2х до 50ти символов</ErrorText>
            )}
          </React.Fragment>
        ) : (
          <List>{currentFolderName}</List>
        )}
      </Table.Cell>
      <Table.Cell style={{ display: 'flex' }}>
        {isEditableName ? (
          <React.Fragment>
            <Button onClick={applyChanges} loading={isLoadingEdit} color="green" icon>
              <Icon name="save" />
            </Button>
            {!isLoadingEdit && (
              <Button onClick={discardChanges} icon>
                <Icon name="share" />
              </Button>
            )}
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Button onClick={onEditClick} color="blue" icon disabled={buttonDisable}>
              <Icon name="edit" />
            </Button>
            <Button
              onClick={toggleDeleteModal}
              color="red"
              icon
              disabled={buttonDisable}
              loading={isLoadingDelete}
            >
              <Icon name="delete" />
            </Button>
          </React.Fragment>
        )}
      </Table.Cell>
      <DeleteConfirmPopup
        isLoadingDelete={isLoadingDelete}
        isOpen={isDeleteModal}
        title={currentFolderName}
        warning={warningWhenDeleting}
        onDelete={onDeleteClick}
        onCancel={toggleDeleteModal}
      />
    </Table.Row>
  );
});

const mapDispatchToProps = (dispatch) => ({
  getTemplateFolders: () => dispatch(getTemplateFolders()),
});

const mapStateToProps = (state) => {
  const { warningWhenDeleting } = state.folders;

  return {
    warningWhenDeleting,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FoldersItems);

const ErrorText = styled.div`
  color: red;
  margin: 5px 0px;
  font-size: 10px;
`;

const List = styled.li`
  list-style-type: none;
`;



// WEBPACK FOOTER //
// ./src/Components/TemplateGenerator/FoldersItems.jsx